import { Box } from "@chakra-ui/react";
import { RiskFactor, riskFactorColors } from "@keita/lanepatrol-sdk";
import { ColorByLegendItem } from "./ColorByLegendItem";
import { tRiskFactor } from "../../../../coding/utils/score-utils";

const crashTypes = Object.values(RiskFactor).reverse();

export const ColorByScore: React.FC = () => {
  return (
    <Box>
      {crashTypes.map((crashType) => (
        <ColorByLegendItem key={crashType} color={riskFactorColors[crashType]}>
          {tRiskFactor(crashType)}
        </ColorByLegendItem>
      ))}
    </Box>
  );
};
